import useLanguage from "../../../../../hooks/useLanguage";

export default function PageError({ status, onRetry }) {
    const { t } = useLanguage();

    return (
        <main className="grid min-h-screen place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold text-gray-600">{t("yourmedias-erro")} {status ?? ""}</p>
                <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                    {t("yourmedias-erro-titulo")}
                </h1>
                <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                    {t("yourmedias-erro-desc")}
                </p>
                {onRetry &&
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <button
                            type="button"
                            onClick={onRetry}
                            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            {t("yourmedias-erro-tentar")}
                        </button>
                    </div>
                }
            </div>
        </main>
    )
}
